import { connect } from 'react-redux';
import { getIsDuperbrowseActive, getCurrentItem, getIsLoading, getLastViewedItem } from '../redux/selectors';
import { exitDuperbrowse } from '../redux/actionCreators';
const mapStateToProps = (state)=>({
        isDuperbrowseActive: getIsDuperbrowseActive(state),
        currentItem: getCurrentItem(state),
        isLoading: getIsLoading(state),
        justClosedAStream: !!getLastViewedItem(state)
    });
const mapDispatchToProps = {
    exitDuperbrowse
};
export default connect(mapStateToProps, mapDispatchToProps);
